import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Facebook } from 'lucide-react';
import { Logo } from './Logo';
const privacySections = [{
  title: '1. Responsable del Tratamiento',
  body: <p data-id="element-23">
        El Código del Bienestar es responsable del tratamiento de los datos
        personales recopilados a través de este sitio web.
      </p>
}, {
  title: '2. Datos que Recopilamos',
  body: <ul className="list-disc pl-5 space-y-1.5" data-id="element-24">
        <li data-id="element-25">Nombre y correo electrónico al momento de la compra</li>
        <li data-id="element-26">Datos de pago procesados por Hotmart</li>
        <li data-id="element-27">Datos de navegación mediante cookies técnicas necesarias</li>
      </ul>
}, {
  title: '3. Finalidad del Tratamiento',
  body: <ul className="list-disc pl-5 space-y-1.5" data-id="element-28">
        <li data-id="element-29">Entrega del producto digital adquirido</li>
        <li data-id="element-30">Envío de comunicaciones relacionadas con tu compra</li>
        <li data-id="element-31">Mejora de nuestros servicios</li>
      </ul>
}, {
  title: '4. Almacenamiento y Seguridad',
  body: <p data-id="element-32">
        Tus datos se almacenan de forma segura. No compartimos tu información
        personal con terceros, excepto con los procesadores de pago necesarios
        para completar tu transacción.
      </p>
}, {
  title: '5. Derechos del Usuario',
  body: <>
        <p className="mb-2" data-id="element-33">Tienes derecho a:</p>
        <ul className="list-disc pl-5 space-y-1.5" data-id="element-34">
          <li data-id="element-35">Acceder a tus datos personales</li>
          <li data-id="element-36">Rectificar datos incorrectos</li>
          <li data-id="element-37">Solicitar la eliminación de tus datos</li>
          <li data-id="element-38">Oponerte al tratamiento de tus datos</li>
        </ul>
        <p className="mt-2" data-id="element-39">
          Para ejercer estos derechos contáctanos a través de nuestra página
          oficial.
        </p>
      </>
}, {
  title: '6. Cookies',
  body: <p data-id="element-40">
        Utilizamos únicamente cookies técnicas necesarias para el funcionamiento
        del sitio web.
      </p>
}, {
  title: '7. Cambios en la Política',
  body: <p data-id="element-41">
        Nos reservamos el derecho de actualizar esta política. Te notificaremos
        de cambios significativos.
      </p>
}];
const termsSections = [{
  title: '1. Naturaleza del Producto',
  body: <p data-id="element-42">
        "El Código del Bienestar" ofrece productos digitales descargables en
        formato PDF. Al realizar tu compra aceptas estos términos y condiciones.
      </p>
}, {
  title: '2. Entrega del Producto',
  body: <p data-id="element-43">
        La entrega es inmediata tras la confirmación del pago. Recibirás un
        correo electrónico con el enlace de descarga de tu guía digital.
      </p>
}, {
  title: '3. Política de Reembolso',
  body: <p data-id="element-44">
        Por tratarse de productos digitales de entrega inmediata, no se aceptan
        devoluciones una vez descargado el producto, salvo error técnico
        comprobado de nuestra parte.
      </p>
}, {
  title: '4. Propiedad Intelectual',
  body: <p data-id="element-45">
        Todo el contenido de nuestras guías digitales — textos, imágenes y
        métodos — es propiedad exclusiva de El Código del Bienestar. Queda
        prohibida su reproducción, distribución o comercialización sin
        autorización expresa.
      </p>
}, {
  title: '5. Uso Permitido',
  body: <p data-id="element-46">
        El producto adquirido es para uso personal únicamente. No está permitida
        su reventa, distribución gratuita ni uso comercial.
      </p>
}, {
  title: '6. Limitación de Responsabilidad',
  body: <p data-id="element-47">
        El contenido de nuestras guías es informativo y educativo. No reemplaza
        ni sustituye el consejo, diagnóstico o tratamiento médico profesional.
        Consulta siempre a tu médico ante cualquier duda sobre tu salud.
      </p>
}, {
  title: '7. Modificaciones',
  body: <p data-id="element-48">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios serán publicados en esta página.
      </p>
}, {
  title: '8. Ley Aplicable',
  body: <p data-id="element-49">Estos términos se rigen por la legislación vigente aplicable.</p>
}];
type FooterAccordionItemProps = {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  sections: {
    title: string;
    body: React.ReactNode;
  }[];
  anchorId: string;
};
function FooterAccordionItem({
  title,
  isOpen,
  onToggle,
  sections,
  anchorId
}: FooterAccordionItemProps) {
  return <div id={anchorId} className="scroll-mt-32" style={{
    borderBottom: '1px solid #374151'
  }} data-id="element-50">
      <button onClick={onToggle} aria-expanded={isOpen} className="w-full flex items-center justify-between py-3 text-left group" data-id="element-51">
        <span className="font-medium transition-colors group-hover:text-white" style={{
        color: '#A8E6CF'
      }} data-id="element-52">
          {title}
        </span>
        <motion.span animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="flex items-center justify-center shrink-0 ml-3" style={{
        color: '#A8E6CF'
      }} data-id="element-53">
          <ChevronDown size={18} strokeWidth={2.5} data-id="element-54" />
        </motion.span>
      </button>

      <AnimatePresence initial={false} data-id="element-55">
        {isOpen && <motion.div key="content" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.35,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-56">
            <div className="rounded-md p-5 my-3 space-y-5 text-sm leading-relaxed" style={{
          backgroundColor: '#3A3A3A',
          color: '#D1D5DB'
        }} data-id="element-57">
              {sections.map((s, i) => <div key={i} data-id="element-58">
                  <h5 className="font-semibold mb-1.5" style={{
              color: '#A8E6CF'
            }} data-id="element-59">
                    {s.title}
                  </h5>
                  <div style={{
              color: '#D1D5DB'
            }} data-id="element-60">
                    {s.body}
                  </div>
                </div>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function Footer() {
  const [openLegal, setOpenLegal] = useState<string | null>(null);
  return <footer className="bg-brand-charcoal text-white pt-20 pb-10" data-id="element-61">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-62">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-8 mb-16" data-id="element-63">
          {/* Left Column */}
          <div className="flex flex-col gap-4" data-id="element-64">
            <Logo width={220} white data-id="element-65" />
            <p className="text-brand-mint italic font-display text-lg mt-2" data-id="element-66">
              Tu cuerpo tiene un código.
              <br data-id="element-67" />
              Aquí te ayudamos a descifrarlo.
            </p>
          </div>

          {/* Center Column */}
          <div className="flex flex-col gap-4 md:items-center" data-id="element-68">
            <div className="flex flex-col gap-4" data-id="element-69">
              <h4 className="font-bold text-lg mb-2" data-id="element-70">Productos</h4>
              <a href="#productos" className="text-brand-mint hover:text-white transition-colors" data-id="element-71">
                Resetea tu Cortisol en 21 Días
              </a>
              <a href="#productos" className="text-brand-mint hover:text-white transition-colors" data-id="element-72">
                El Código del Sueño Profundo
              </a>
              <a href="#productos" className="text-brand-mint hover:text-white transition-colors" data-id="element-73">
                Desintoxica tu Mente
              </a>
              <span className="text-brand-mint/60 cursor-not-allowed" data-id="element-74">
                Próximamente...
              </span>
            </div>
          </div>

          {/* Right Column */}
          <div className="flex flex-col gap-4" data-id="element-75">
            <h4 className="font-bold text-lg mb-2" data-id="element-76">Legal</h4>

            <div className="flex flex-col" data-id="element-77">
              <FooterAccordionItem title="Política de Privacidad" anchorId="privacidad" isOpen={openLegal === 'privacy'} onToggle={() => setOpenLegal(prev => prev === 'privacy' ? null : 'privacy')} sections={privacySections} data-id="element-78" />
              <FooterAccordionItem title="Términos y Condiciones" anchorId="terminos" isOpen={openLegal === 'terms'} onToggle={() => setOpenLegal(prev => prev === 'terms' ? null : 'terms')} sections={termsSections} data-id="element-79" />
            </div>

            <h4 className="font-bold text-lg mt-4 mb-2" data-id="element-80">Síguenos</h4>
            <a href="https://www.facebook.com/profile.php?id=61589346766845" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors" style={{
            color: '#BFDBFE'
          }} data-id="element-81">
              <Facebook size={20} data-id="element-82" />
              <span data-id="element-83">@ElCódigoDelBienestar</span>
            </a>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 pt-8 flex flex-col items-center text-center gap-4" data-id="element-84">
          <p className="text-brand-mint text-sm" data-id="element-85">
            © 2026 El Código del Bienestar. Todos los derechos reservados.
          </p>
          <p className="text-brand-mint/70 text-xs max-w-2xl" data-id="element-86">
            ⚕️ El contenido es informativo y no reemplaza consejo médico
            profesional.
          </p>
        </div>
      </div>
    </footer>;
}